import { Logo } from '@vwfs-bronson/bronson-react';
import React, { FunctionComponent, useEffect, useState } from 'react';
import { getLogosSrc } from '../../services/brand';
import { useNavigate } from '../../services/routing';

export type HeaderLogoProps = {
  navigationFn?: () => void;
};

export const HeaderLogo: FunctionComponent<HeaderLogoProps> = ({ navigationFn }) => {
  const [logoSrc, setLogoSrc] = useState({ normal: '', small: '' });
  const navigate = useNavigate();

  useEffect(() => {
    Promise.resolve(getLogosSrc()).then((_logoSrc) => {
      setLogoSrc({
        normal: _logoSrc.logoDefault,
        small: _logoSrc.logoSmall,
      });
    });
  }, []);

  return (
    <Logo
      testId="appHeaderLogo"
      src={logoSrc.normal}
      srcSmall={logoSrc.small}
      onClick={() => {
        if (navigationFn) {
          navigationFn();
        } else {
          navigate.dashboardHome();
        }
      }}
    />
  );
};
